export const TEMPLATE_FIELD_NAMES = {
  ID: 'id',
  CATEGORY_ID: 'issueTemplateCategoryId',
  IS_ACTIVE: 'isActive',
  CREATED_BY: 'createdBy',
  CREATED_AT: 'createdAt',
  UPDATED_BY: 'updatedBy',
  UPDATED_AT: 'updatedAt',
  NUMBER_OF_ISSUES: 'numberOfIssues',
  ISSUE_ATTRIBUTES: 'issueAttributes'
};

export const TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES = {
  TITLE: 'title',
  TYPE_ID: 'typeId',
  SUBTYPE_ID: 'issueSubtypeId',
  STATUS: 'status',
  ASSIGNED_TO: 'assigneeId',
  ASSIGNED_TO_TYPE: 'assignedToType',
  DUE_DATE: 'daysTilDueDate',
  LOCATION_ID: 'locationId',
  LOCATION_DETAILS: 'locationDetails',
  OWNER_ID: 'ownerId',
  ROOT_CAUSE_ID: 'rootCauseId',
  DESCRIPTION: 'description',
  CUSTOM_ATTRIBUTES: 'customAttributes'
};

export const TEMPLATE_PERMITTED_ACTIONS = {
  DELETE: 'delete',
  EDIT: 'edit'
};

export const TEMPLATE_CATEGORY_FIELD_NAMES = {
  TITLE: 'title',
  IS_ACTIVE: 'isActive',
  ID: 'id'
};

export const TEMPLATE_CATEGORY_PERMITTED_ACTIONS = {
  EDIT: 'edit',
  DELETE: 'delete'
};

export const TEMPLATE_ACTIVE_TYPES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const RECENTLY_USED_TEMPLATE_LOCAL_STORAGE_PREFIX = 'recentlyUsedTemplates';
export const RECENTLY_USED_TEMPLATES_SIZE = 5;

export const CATEGORY_DELETE_CONFIRM_METHOD = {
  SELECT_TARGET: 'SELECT_TARGET',
  CONFIRM_DELETE: 'CONFIRM_DELETE',
  NONE: 'NONE'
};
